import { render } from "./CsvTableEditor.vue?vue&type=template&id=1c42495f&scoped=true"
import script from "./CsvTableEditor.vue?vue&type=script&lang=js"
export * from "./CsvTableEditor.vue?vue&type=script&lang=js"

import "./CsvTableEditor.vue?vue&type=style&index=0&id=1c42495f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c42495f"]])

export default __exports__